import script from "./ButtonCancel.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonCancel.vue?vue&type=script&setup=true&lang=js"

export default script